<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[3]" :innerTitle="navList[3].navChildList[0].name" :innerLink="navList[3].navChildList[0].toLink"></inner-nav>
      <div class="realty-content">
        <!--<div class="realty-title">-->
        <!--<h1>旗下子公司</h1>-->
        <!--<h3>xxxxx</h3>-->
        <!--</div>-->
        <div class="realty-list">
          <ul>
            <li v-for="(item,index) in realtyList" :key="index">
              <img v-if="item.urlList" :src="item.urlList[0]" alt="">
              <div class="realty-msg">
                <div>
                  <h2>{{item.title}}</h2>
                  <h3>{{item.publicDate | formatDate}}</h3>
                </div>
                <div class="content-ellipsis">{{item.content | delHtmlTag}}</div>
                <div class="go" @click="realtyDetailFn(item.id)">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </li>
          </ul>

        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        realtyList:[]
      }
    },
    components: {
      ad,
      InnerNav
    },
    filters: {
      formatDate(time) {
        let date= time ? time.split('T'):'';
        return date[0];
      },
      delHtmlTag(str){
        if (str){
          var s=str.replace(/<[^>]*>|/g,"");
          return s.replace(/&nbsp;/ig, "");//去掉所有的html标记
        }
      }
    },
    methods:{
      realtyDetailFn(id){
        this.$router.push({path:`/main/business/realtyDetail?id=${id}`});
      }
    },
    created(){
      this.$http.get(`/outer/announcement/listAnnouncements.do`, {
        functionCode:2
      }).then((res)=>{
          this.realtyList=res.data.list
          //图片有问题
      })
    }
  }
</script>

<style scoped lang="less">
  .realty-content{
    font-family:PingFangSC-Medium;
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .realty-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .realty-list{
        width:12rem;
          li{
            overflow: hidden;
            clear: both;
            margin-bottom:.5rem;
            width:100%;
            height:4rem;
              img{
                float: left;
                width:50%;
                height:100%;
              }
              .realty-msg{
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                padding:1rem .5rem;
                /*padding-top:1.2rem;*/
                float: right;
                width:50%;
                height:100%;
                  div:nth-child(1){
                    h2{
                      font-size:.24rem;
                      font-weight:500;
                      color:#000;
                      line-height:.4rem;
                    }
                    >h3{
                       font-size:.14rem;
                       font-weight:500;
                       line-height:.2rem;
                       color: #999999;
                     }
                  }
                   div:nth-child(2){
                     width:100%;
                     overflow: hidden;
                     margin-top:.2rem;
                     font-size:.14rem;
                     font-weight:500;
                     color:#666666;
                     line-height:.24rem;
                     text-overflow:ellipsis;
                     display:-webkit-box;
                     -webkit-line-clamp:3;
                     -webkit-box-orient:vertical;
                   }
                  .content-ellipsis{
                    position:relative;
                    height:.72rem;
                    overflow:hidden;
                  }
                  .content-ellipsis:after{
                    content:"...";
                    position:absolute;
                    bottom:0;
                    right:0;
                    padding:0 0.1rem 1px .45rem;
                    background:url('/static/img/ellipsis_bg.png') repeat-y;
                  }
                   .go{
                     width:1.2rem;
                     height:.4rem;
                     border-radius:1rem;
                     border:1px solid #333333;
                     line-height:.4rem;
                     text-align: center;
                     margin-top:.3rem;
                     color: #333333;
                     font-weight:bolder!important;
                     cursor: pointer;
                   }
              }
          }
          li:nth-child(even){
            .realty-msg{
              float: left;
              padding-left:0;
            }
            img{
              float: right;
            }
          }
          .realty-msg:hover{
            .go{
              background: red;
              border: 0;
            }
          }


      }


  }
</style>

<style lang="less">
  .realty-list{
    .el-icon-arrow-right{
        font-weight: bolder;
    }
    .realty-msg:hover{
      .el-icon-arrow-right{
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/realty.vue